<template>
  <!-- 战团管理-宗旨审核 -->
  <div class="battle_objective-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.name"
            placeholder="请输入战队名称搜索"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.id" placeholder="请输入战团UID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column label="战队名称" align="center">
          <template slot-scope="{ row }">{{ row.team.name }}</template>
        </el-table-column>
        <el-table-column label="战队uid" align="center">
          <template slot-scope="{ row }">{{ row.team.id }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间" align="center">
        </el-table-column>
        <el-table-column prop="aim" label="宗旨" align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-col :span="30">
              <el-button size="small" type="primary" @click="through(row)"
                >通过</el-button
              >
              <el-button size="small" type="danger" @click="refused(row)"
                >拒绝</el-button
              >
            </el-col>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'

export default {
  name: 'battle_objective',
  components: {
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        name: '',
        id: '',
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}member_card_user`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData(`team_aim`, params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    through(rowInfo) {
      //通过
      let params = {
        status: 2
      }
      patchApiData(`team_aim/${rowInfo.id}`, params).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message);
          this.getData()
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
      })
    },
    refused(rowInfo) {
      //拒绝
      this.$confirm('确定要拒绝吗1？', {
        type: 'warning'
      }).then(res => {
        let params = {
          status: 3
        }
        patchApiData(`team_aim/${rowInfo.id}`, params).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message);
          }
        })
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.battle_objective-box {
  header {
  }

  .body-box {
  }
}
</style>